/**
 * Kundenportal für Großunternehmen - Ummeldungs-API
 *
 * Contact: we.it.ikp-team@wienenergie.at
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Adresse } from './adresse.model';


export interface Produktdaten { 
    vertragsnummer: string;
    zaehlpunktnummer: string;
    zaehlerNr?: string;
    produkt?: Produktdaten.ProduktEnum;
    isSmartMeter?: boolean;
    zaehlerstand?: string;
    hasNoZaehlerstand?: boolean;
    adresse?: Adresse;
}
export namespace Produktdaten {
    export const ProduktEnum = {
        STROM: 'STROM',
        GAS: 'GAS'
    } as const;
    export type ProduktEnum = typeof ProduktEnum[keyof typeof ProduktEnum];
}


